import React, { useState } from 'react';

import PlayerView from '../PlayerView/PlayerView';
import { useBreadcrumbs } from '../../hooks';
import { pathTo } from '../../App/routes';
import { usePlayer } from '../shared/hooks';

const createBreadcrumbs = player =>
  player && [
    { title: 'Players', url: pathTo('players') },
    {
      title: `[${player.id}] ${player.normalized}`,
      url: pathTo('player', player.id),
    },
  ];

const TeamViewPage = ({ playerId }) => {
  const player = usePlayer(playerId);
  const [onOffType, setOnOffType] = useState('offense');

  useBreadcrumbs(createBreadcrumbs, [player]);

  return (
    <PlayerView
      player={player}
      onOffType={onOffType}
      handleOnOffChange={setOnOffType}
    />
  );
};

export default TeamViewPage;
